import { render, staticRenderFns } from "./EntityTrips.vue?vue&type=template&id=1f9d1a8a&scoped=true&"
import script from "./EntityTrips.vue?vue&type=script&lang=js&"
export * from "./EntityTrips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9d1a8a",
  null
  
)

export default component.exports